import i18n from '../../../i18n'
import { baseDateInput, baseTextInput, baseNumeralInput } from '../fieldTypes'
import { evidenceDiaryDetailSearchFields } from './fields'

export const evidenceDiaryDetailSearchFieldTypes = () => {
    return {
        [evidenceDiaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID]: {
            ...baseTextInput,
            name: evidenceDiaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID,
            label: i18n.t('app.common.propertyId'),
            colProps: { sm: 12 },
        },
        [evidenceDiaryDetailSearchFields.FULL_NAME_SELLER]: {
            ...baseTextInput,
            name: evidenceDiaryDetailSearchFields.FULL_NAME_SELLER,
            label: i18n.t('form.detailSearch.diary.fullNameSeller'),
            colProps: { sm: 12 },
        },
        [evidenceDiaryDetailSearchFields.LOCATION]: {
            ...baseTextInput,
            name: evidenceDiaryDetailSearchFields.LOCATION,
            label: i18n.t('app.common.location'),
            colProps: { sm: 12 },
        },
        [evidenceDiaryDetailSearchFields.STREET]: {
            ...baseTextInput,
            name: evidenceDiaryDetailSearchFields.STREET,
            label: i18n.t('app.common.street'),
            colProps: { sm: 12 },
        },
        [evidenceDiaryDetailSearchFields.PRICE_FROM]: {
            ...baseNumeralInput,
            name: evidenceDiaryDetailSearchFields.PRICE_FROM,
            placeholder: i18n.t('app.common.from'),
            colProps: { sm: 6, className: 'pe-0' },
        },
        [evidenceDiaryDetailSearchFields.PRICE_TO]: {
            ...baseNumeralInput,
            name: evidenceDiaryDetailSearchFields.PRICE_TO,
            placeholder: i18n.t('app.common.to'),
            colProps: { sm: 6, className: 'pe-0' },
        },
        [evidenceDiaryDetailSearchFields.CREATED_FROM]: {
            ...baseDateInput,
            name: evidenceDiaryDetailSearchFields.CREATED_FROM,
            placeholder: i18n.t('app.common.from'),
            colProps: { sm: 6, className: 'pe-0' },
        },
        [evidenceDiaryDetailSearchFields.CREATED_TO]: {
            ...baseDateInput,
            name: evidenceDiaryDetailSearchFields.CREATED_TO,
            placeholder: i18n.t('app.common.to'),
            colProps: { sm: 6, className: 'pe-0' },
        },
    }
}
